import './index.scss'
import { Controller as BaseController } from 'stimulus'
export class Controller extends BaseController {
  static values = {
    expanded: Boolean
  };

  connect() {
    if (this.hasExpandedValue) {
      this.updateFlyout()
    }
  }

  expandedValueChanged() {
    if (this.hasExpandedValue) {
      this.updateFlyout()
    }
  }

  toggle(event) {
    this.expandedValue = !this.expandedValue
  }

  updateFlyout() {
    if (this.expandedValue === true) {
      this.element.removeAttribute('hidden')
    } else {
      this.element.setAttribute('hidden', 'true')
    }
  }
}
